export enum Orientation {
    landscape = 'landscape',
    portrait = 'portrait',
}
